import type { CustomIconProps } from '../types';

const VoteUp = ({ width, height }: CustomIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '22'}
        height={height ?? '16'}
        viewBox="0 0 22 16"
        fill="none"
    >
        <path
            d="M19.0278 15H2.91432C2.10653 15 1.6321 14.0918 2.09354 13.4288L9.94368 2.14935C10.3357 1.58609 11.1656 1.57603 11.5711 2.12961L19.8344 13.409C20.3184 14.0696 19.8466 15 19.0278 15Z"
            stroke="#414042"
            strokeWidth="2"
        />
    </svg>
);

export default VoteUp;
